import { NgTemplateOutlet } from '@angular/common';
import { Component, Input, output, input, ChangeDetectionStrategy } from '@angular/core';
import type { UntypedFormControl } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@core/i18n-legacy';

import { BadgeComponent } from '../../common/badge/badge.component';
import { IconComponent } from '../../common/icon/icon.component';
import { RtTooltip } from '../../common/tooltip/tooltip.directive';
import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
  selector: 'rt-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CheckboxComponent,
    ReactiveFormsModule,
    BadgeComponent,
    TranslatePipe,
    NgTemplateOutlet,
    RtTooltip,
    IconComponent,
  ],
})
export class SelectableCardComponent {
  public readonly control = input<UntypedFormControl>(undefined!);
  public readonly disabled = input<boolean>(false);
  public readonly label = input<string>(undefined!);
  public readonly isNew = input<boolean | undefined>(false);
  public readonly tooltip = input<string>(undefined!);
  @Input() public description: string;
  @Input() public helpTooltip?: string;

  public valueChanges = output<string | boolean | null>();
}
